module.exports = __webpack_public_path__ + "07_hair_gold.5e7d4a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/07_hair_gold.png
// module id = xEea
// module chunks = 0